import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class HeaderShowHideService {
    public headerStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    display(value: boolean) {
        this.headerStatus.next(value);
    }
    
}